import { ThinkingOrb } from 'thinking-orbs'
import { useState } from 'react'
import { useSceneStore } from '../sceneStore'
import { launchOAuthConnect, oauthProviderLabel, stripUrls } from '../utils/oauthConnect'
import { formatUserChoiceMessage, INLINE_CHOICE_LIMIT } from '../utils/userChoiceUtils'

export function Dialogue({
  prevText,
  activeWho,
  activeText,
  isUserTurn,
  uiAction,
  onUserChoice,
  agentActivity,
}) {
  const { openPanel } = useSceneStore()
  const [submitting, setSubmitting] = useState(false)
  const oauthAction = !isUserTurn && uiAction?.type === 'oauth_connect' ? uiAction : null
  const choiceAction = !isUserTurn && uiAction?.type === 'user_choice' ? uiAction : null
  const draftAction = !isUserTurn && uiAction?.type === 'draft_review' ? uiAction : null
  const displayText = oauthAction ? stripUrls(activeText) : activeText
  const providerLabel = oauthAction ? oauthProviderLabel(oauthAction.provider) : null
  const inlineOptions = choiceAction?.options?.slice(0, INLINE_CHOICE_LIMIT) || []
  const hiddenCount = (choiceAction?.options?.length || 0) - inlineOptions.length
  const showActivity = Boolean(agentActivity?.active)

  const handleOAuthClick = async (event) => {
    event.preventDefault()
    try {
      await launchOAuthConnect(oauthAction.provider)
    } catch {
      // OAuth panel is the fallback if popup launch fails.
    }
  }

  const handleChoiceClick = async (option) => {
    if (!onUserChoice || submitting) return
    setSubmitting(true)
    try {
      await onUserChoice(formatUserChoiceMessage(choiceAction.field, option))
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <div className="dialogue">
      <div className="prev">{prevText}</div>
      <div className={`now ${isUserTurn ? 'user' : ''}`}>
        <span className="who">{activeWho}</span>
        {displayText}
        {oauthAction ? (
          <>
            {' '}
            <button type="button" className="dialogue-oauth-link" onClick={handleOAuthClick}>
              Connect {providerLabel}
            </button>
          </>
        ) : null}
        {choiceAction && inlineOptions.length > 0 ? (
          <div className="dialogue-choice-row" role="group" aria-label={choiceAction.prompt || 'Choices'}>
            {inlineOptions.map((option) => (
              <button
                key={option.value}
                type="button"
                className="dialogue-choice-chip"
                onClick={() => handleChoiceClick(option)}
                disabled={submitting}
              >
                {option.label}
              </button>
            ))}
            {hiddenCount > 0 ? (
              <span className="dialogue-choice-more">+{hiddenCount} more in panel</span>
            ) : null}
          </div>
        ) : null}
        {draftAction ? (
          <>
            {' '}
            <button
              type="button"
              className="dialogue-oauth-link"
              onClick={() => openPanel('draft', { payload: { drafts: draftAction.drafts || [] } })}
            >
              Review draft
            </button>
          </>
        ) : null}
      </div>
      {showActivity ? (
        <div className="dialogue-activity" role="status" aria-live="polite">
          <ThinkingOrb
            state={agentActivity.orbState}
            size={64}
            theme="dark"
            aria-label={agentActivity.label}
          />
          <span className="dialogue-activity-label">{agentActivity.label}</span>
        </div>
      ) : null}
    </div>
  )
}
